import * as React from "react";
import { CategoryOneTimeOffer } from "../categoryOneTimeOffer/categoryOneTimeOffer.js";
import "./categoryOneTimeOffers.css";
export function CategoryOneTimeOffers(props) {
    return (React.createElement("div", { className: "one-time-offers-container" },
        props.offers.length > 0 && (React.createElement("h2", { className: "one-time-offers-title" }, "Oferty")),
        props.offers
            .filter((offer) => offer.isBeforePayment == false ||
            offer.isBeforePayment == undefined)
            .map((offer, index) => (React.createElement(CategoryOneTimeOffer, { offer: offer, key: index, categoryIndex: props.categoryIndex })))));
}
